import { render, staticRenderFns } from "./cv.vue?vue&type=template&id=6d188872"
import script from "./cv.vue?vue&type=script&lang=js"
export * from "./cv.vue?vue&type=script&lang=js"
import style0 from "./cv.vue?vue&type=style&index=0&id=6d188872&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports